export const MERCHANTS_QUERY_KEY = "merchants"
export const TERMINALS_QUERY_KEY = "terminals"
export const MERCHANT_DETAIL_TERMINALS_QUERY_KEY =
  "merchant_details_terminals"
export const USERS_QUERY_KEY = "users"
export const ROLES_QUERY_KEY = "roles"
export const PERMISSIONS_QUERY_KEY = "permissions"
export const TOP_SCORING_MERCHANTS_QUERY_KEY = "top-scorers"
